export default "__VITE_ASSET__Wcn24U19__"